import { Link, useNavigate } from 'react-router-dom';
import SocialLinks from '../social-links/SocialLinks';
import { useAuth } from '../../../context/AuthContext';
import { useEffect, useState } from 'react';
import { HiClock, HiPhone } from 'react-icons/hi';
import './Footer.scss';
import { getLanguage } from '../../../utils/Helper';

const Footer = () => {
  const authContext= useAuth();
  const [footerData, setFooterData]= useState([]);
  const navigate= useNavigate();
  const lang = getLanguage();
  
  const handleCollectionPaht= path =>{
    return path.toString().toLowerCase().trim().split(" ").join("-");
  }

  useEffect(() => {
    if (authContext?.systemCollections) {
      setFooterData(authContext.systemCollections);
    }
  }, [authContext?.systemCollections]);

  return (
    <footer className="footer-section">
      <div className="container">
        <div className="row">
          <div className='col-md-6 col-12'>
            <div className='row'>
              <div className="col-12 mt-4 pt-4">
                <Link to={"/"} className="footer-logo-container">
                  <img
                      src={"/assets/login-form-logo.png"}
                      alt="footer visual"
                      className="object-fit-fill mx-2 footer-logo"
                      style={{
                        borderRadius: "10px",
                        height: "auto",
                      }}
                    />
                </Link>
              </div>

              <div className="col-12">
                {/* App Download Section */}
                  <div className="app-section align-items-center pt-3">
                      <div className="social-section">
                        <SocialLinks />
                      </div>
                  </div>
              </div>
            </div>
          </div>

          <div className="col-md-6 col-12">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d863.8971952203083!2d31.317303269627487!3d29.99124585996777!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1458398040fdcfef%3A0x72176d24aba06ea3!2sAddmix%20Store!5e0!3m2!1sen!2seg!4v1770815254405!5m2!1sen!2seg" width="100%" height="300" style={{border: "0px"}} loading="lazy" referrerPolicy="no-referrer-when-downgrade">
            </iframe>
          </div>
          

          {/* Main Footer Content */}
          <div className="footer-content mx-lg-4 mx-0 px-lg-0 px-3">
            <div className="row">
              <div className="col-lg-3 col-md-4 col-sm-6 mb-4 text-start">
                <p className='text-light'>
                
                {
                  lang === 'EN'?
                  "Addmix Store is a comprehensive online store that offers a smooth and secure shopping experience, featuring a wide variety of high-quality products at competitive prices. Our goal is to meet our customers’ needs in one place and deliver orders quickly and professionally."
                  :"أدميكس هو متجر إلكتروني متكامل يوفّر تجربة تسوّق سهلة وآمنة، مع مجموعة متنوعة من المنتجات عالية الجودة بأسعار تنافسية. هدفنا هو تلبية احتياجات عملائنا من مكان واحد وتوصيل الطلبات بسرعة واحترافية."
                }
                </p>
                <div className="footer-info-icon text-light">
                  <p>
                    <HiPhone/>
                    <span className='px-2'> 01006611664 </span>
                  </p>
                  <p>
                    <HiClock/>
                    <span className='px-2'>
                       
                      {lang === 'EN' ? "Everyday from 9:00 AM to 2:00 AM"
                       : "يومياً من 9 صباحاً حتى 2:00 صباحاً"}
                    </span>
                  </p>
                </div>
              </div>

              {footerData.map((collection, index) => (
                <div key={index} className="col-lg-2 col-md-4 col-sm-6 mb-4">
                  <h6 
                    className="footer-heading"
                    onClick={()=> navigate(handleCollectionPaht(`/collection/${collection.name_url}`))}

                  >
                    {collection.name}
                  </h6>
                  <ul className="footer-links">
                    {collection?.categories.map(category=> (
                      <li key={category.id}>
                        <Link 
                          to={handleCollectionPaht(`/collection/${collection.name_url}/${category.name_url}`)}
                          className="footer-link"
                        >
                          {category.name}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}

              {/* adding privacy policy, about us, contact us links */}
              <div className="col-lg-2 col-md-4 col-sm-6 mb-4">
                <h6 
                  className="footer-heading"
                  onClick={()=> navigate("/about-us")}
                >
                  {lang === 'EN' ? "About Us" : "من نحن"}
                </h6>
              </div>
              <div className="col-lg-2 col-md-4 col-sm-6 mb-4">
                <h6 
                  className="footer-heading"
                  onClick={()=> navigate("/privacy-policy")}
                >
                  {lang === 'EN' ? "Privacy Policy" : "سياسة الخصوصية"}
                </h6>
              </div>
              <div className="col-lg-2 col-md-4 col-sm-6 mb-4">
                <h6 
                  className="footer-heading"
                  onClick={()=> navigate("/contact-us")}
                >
                  {lang === 'EN' ? "Contact Us" : "اتصل بنا"}
                </h6>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Bottom Footer */}
      <div className="footer-bottom">
        <div className="row align-items-center">
          <div className="col-md-12">
            <div className="footer-logo w-100">
              <p className="copyright m-auto">©  <b>Addmix-Store</b> 2026, All rights reserved developed by Addmix Dev Team.</p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;